import { CSSProperties } from "react"
import { colors, fonts, useMediaQuery } from "../../Styles"

interface Setting_Props {
  startEnhancer: JSX.Element
  header: string
  content: JSX.Element
  overrides?: {
    content?: CSSProperties
  }
}

export default function Setting({ startEnhancer, header, content, overrides }:Setting_Props) {
  const mobileXs = useMediaQuery(`(max-width: 570px)`);
  const defaultPadding = { padding: mobileXs ? "10px" : "10px 20px" };
  const contentStyle: CSSProperties = { ...defaultPadding, ...overrides?.content };

  return(
    <div style={{backgroundColor: colors.greyLightTertiary, boxSizing: "border-box", width: "100%", border: "5px solid"+colors.greyPrimary, borderRadius: "10px", display: "grid", gridAutoColumns: mobileXs ? "1fr" : "200px 1fr", gridAutoRows: mobileXs ? "50px 1fr" : "1fr", maxWidth: "1050px"}}>
      
      <div style={{padding: "0px 10px", boxSizing: "border-box", backgroundColor: colors.greyPrimary, display: "flex", justifyContent: mobileXs ? "center" : "start", alignItems: mobileXs ? "center" : "start", gridArea: "1/1/2/2", width: "100%"}}>
        <div style={{display: "flex", height: "50px", justifyContent: "start", alignItems: "center", gap: "10px"}}>
          <div style={{width: "25px"}}>{startEnhancer}</div>
          <p style={{...fonts.header, ...fonts.fontSize4, color: colors.greyLightTertiary}}>{header}</p>
        </div>
      </div>

      <div style={{gridArea: mobileXs ? "2/1/3/2" : "1/2/2/3", ...contentStyle, width: "100%", boxSizing: "border-box"}}>{content}</div>

    </div>
  )
}